import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=2cb199bc&scoped=true&"
import script from "./Unauthorized.vue?vue&type=script&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&lang=js&"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=2cb199bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb199bc",
  null
  
)

export default component.exports